import { computed } from 'vue';
import { getVm } from '@/helpers/vm-helper';

import type { SponsoredRecommendationsInput, SraPlacement } from '@/@types/graphql-types';

import { ObjectType, SraFormat } from '@/@types/graphql-types';
import { Platform } from '@/@types/graphql-types';
import { TrackingAppId } from '@/helpers/tracking/tracking-helper';

interface UseSponsoredRecOptions {
	pageType: string;
	placement: SraPlacement;
	testingMode?: boolean;
}

export const supportedFormats = [SraFormat.Image, SraFormat.Video];
export const supportedObjectTypes = [
	ObjectType.Movie,
	ObjectType.Show,
	ObjectType.GenericTitleList,
	ObjectType.ShowSeason,
];

export function getAllowSponsoredRecommendations({ pageType, placement, testingMode = false }: UseSponsoredRecOptions) {
	const vm = getVm();

	/**
	 * If there is a query parameter 'sr' in the URL with the campaign name
	 * Se force the SR campaign to show
	 * However, the user needs to be in the correct country/platform/placement
	 * E.g. https://www.justwatch.com/uk?sr=WICKED_LITTLE_LETTERS_BURST3_GB_SRA
	 */
	const testingCampaignName = computed(() => {
		const srQueryParam = vm.$route.query['sr'] as string | null;
		return srQueryParam ?? null;
	});

	return {
		pageType,
		placement,
		country: vm.$store.getters['language/country'],
		language: vm.$store.getters['language/language'],
		appId: TrackingAppId,
		platform: Platform.Web,
		// Have every SR Placement supoort every format
		supportedFormats,
		supportedObjectTypes,
		testingMode: testingMode || testingCampaignName.value != null,
		testingModeCampaignName: testingCampaignName.value,
	} as SponsoredRecommendationsInput;
}
